export default __webpack_public_path__ + "static/media/sucess-check.d0dcde77.svg";